import { TagBadge } from '@components/TagBadge'
import type { ProjectStatus } from '@store/reducers/dashboard/statuses'
import type React from 'react'

interface Props {
  status: ProjectStatus | null
}

export const ProjectStatusBadge: React.FC<Props> = ({ status }) => {
  if (!status) {
    return null
  }
  return <TagBadge title={status.title} color={status.color} />
}
